import { useProject } from '@contexts/Project.context';

/**
 * Whether the sidebar with the given id is currently open.
 *
 * `activeSidebars` is the source of truth for sidebar visibility (SidebarTemplate
 * renders nothing unless its id is in that list). Derive visibility-dependent
 * state from this rather than from a panel's `onHide`, which fires only for the
 * header's close icon — not when a sidebar is removed any other way.
 *
 * @param {string} sidebarId
 * @returns {boolean}
 */
const useIsSidebarOpen = sidebarId => {
	const { activeSidebars } = useProject();
	return activeSidebars.some(sidebar => sidebar.sidebarId === sidebarId);
};

export default useIsSidebarOpen;
